export const UploadStatus = {
  STATUS_INITIAL: 0,
  STATUS_SAVING: 1,
  STATUS_SUCCESS: 2,
  STATUS_FAILED: 3
}
